/* eslint-disable react-hooks/exhaustive-deps */
import './packageGrid.css';
import { useEffect, useRef, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import TripCard from '../../components/tripCard/TripCard';
import ReactLoading from 'react-loading';
import TitleBar from '../../components/titleBar/titleBar';
import { getOrganizerTrips } from './getOrganizerTrips/getOrganizerTrips';
import { getOrganizerInfo } from './getOrganizerInfo/getOrganizerInfo';
import CustomHeader from '../../webPageSections/header/orgHeader/CustomHeader';
import logo from '../../assets/images/trvto-logo.png';
import EmptyPage from '../../components/empty-page/emptyPage';
import { useTempOrg } from '../../context/TempOrgContext';

const PackageGridDetails = () => {
    const [data, setData] = useState([]);
    const [organizer, setOrganizer] = useState({});
    const [type, setType] = useState('trip');
    const [loading, setLoading] = useState(false);
    const [limit] = useState(3);
    const [offset, setOffset] = useState(0);
    const [hasMore, setHasMore] = useState(true);
    const loaderRef = useRef(null);
    const { id } = useParams();
    const [searchValue, setSearchValue] = useState('');
    const [debounceSearch, setDebounceSearch] = useState('');
    const { setTempOrg } = useTempOrg();

    useEffect(() => {
        setType((prev) => prev);
    }, []);

    useEffect(() => {
        if (!id) return;
        getOrganizerInfo(type, id, setOrganizer, setLoading);
    }, [id]);

    useEffect(() => {
        if (!id) return;
        getOrganizerTrips(type, id, limit, offset, setHasMore, setData, setLoading);
    }, [offset]);

    // useEffect(() => {
    //     if (!loaderRef.current || !hasMore) return;

    //     const observer = new IntersectionObserver((entries) => {
    //         if (entries[0].isIntersecting) {
    //             setOffset((prev) => prev + limit);
    //         }
    //     });

    //     observer.observe(loaderRef.current);

    //     return () => {
    //         if (loaderRef.current) observer.unobserve(loaderRef.current);
    //     };
    // }, [loaderRef, hasMore]);

    useEffect(() => {
        const titleBar = document.querySelector('.customTitle');
        if (!titleBar) return;

        let ticking = false;

        const handleScroll = () => {
            const scrollY = window.scrollY;
            const shouldBeScrolled = scrollY >= 70;

            if (shouldBeScrolled) {
                titleBar.classList.add('scrolled');
            } else {
                titleBar.classList.remove('scrolled');
            }

            ticking = false;
        };

        const onScroll = () => {
            if (!ticking) {
                window.requestAnimationFrame(handleScroll);
                ticking = true;
            }
        };

        window.addEventListener('scroll', onScroll);
        handleScroll();

        return () => {
            window.removeEventListener('scroll', onScroll);
        };
    }, []);
    useEffect(() => {
        if (!id || !organizer?.companyName) return;

        const tempOrgData = {
            id,
            orgLogo: organizer?.logo,
            orgName: organizer?.companyName,
            contactPerson: organizer?.contactPerson
        };

        // Update global state (TempOrgContext will handle localStorage sync automatically)
        setTempOrg(tempOrgData);

        // Broadcast to other tabs/components
        const channel = new BroadcastChannel('org_channel');
        channel.postMessage({ type: 'UPDATE_ORG', payload: tempOrgData });

        // Cleanup
        return () => channel.close();
    }, [id, organizer, setTempOrg]);

    useEffect(() => {
        const handler = setTimeout(() => {
            if (debounceSearch.length >= 3) {
                setSearchValue(debounceSearch);
            } else {
                setSearchValue('');
            }
        }, 100);

        return () => clearTimeout(handler);
    }, [debounceSearch]);

    const filterData = data.filter((item) => item?.title?.toLowerCase().includes(searchValue.toLowerCase()));
    return (
        <>
            {/* <TitleBar image={organizer?.logo} title={organizer?.companyName} className='customTitle aboutSticky' /> */}
            {id && (
                <CustomHeader
                    leftItems={['logo']}
                    logo={organizer?.logo}
                    companyName={organizer?.companyName}
                    centerItems={['search']}
                    rightItems={['menuIcons']}
                    onSearch={setDebounceSearch}
                    searchValue={debounceSearch}
                    setDebounceSearch={setDebounceSearch}
                />
            )}
            {loading && (
                <div className='loadingBackground'>
                    <ReactLoading type='spin' color='#006aff' className='loadingSpin' />
                </div>
            )}
            <div className='custom-container'>
                <div className='blogsGrid_org'>
                    <TripCard imageData={filterData} />
                </div>
                {/* <div className='powered-by-logo'>
                    <h1>Powered By</h1>
                    <Link to='/'>
                        <img alt='trvto logo' src={logo} className='headerLogoImg' />
                    </Link>
                </div> */}
                {filterData?.length === 0 && <EmptyPage />}
                <div ref={loaderRef} style={{ height: '40px' }}></div>
            </div>
        </>
    );
};

export default PackageGridDetails;
